import { useState } from 'react';
import AccountModal from '@/pages/AccountModal';
import NewTermsDialog from '@/components/core/NewTermsDialog';
import HowToPlayModal from '@/pages/HowToPlayModal';
import HiatusModal from '@/components/lobby-details/lobby-common-popus/HiatusModal';
import MilestoneModal from '@/components/lobby-details/lobby-common-popus/MilestoneModal';
import CrowdLockIntroModal from '@/components/events/CrowdLockIntroModal';
import SmartRatingCelebratory from '@/components/lobby-details/SmartRatingCelebratory';
// import IntroVideoDialog from '@/components/core/IntroVideoDialog';
// import NewFeatureUserInsightPopup from '@/components/core/NewFeatureUserInsightPopup';
import { AuthModal } from '@/components/auth/modals/auth.modal';
import ProductUpdatePopup from '@/components/core/ProductUpdatePopup';
import { UsersDto, ProductUpdatePopupDto } from '@sportspredict/shared';
import type { Achievement } from '@/types/layout.types';

interface LayoutModalsProps {
	accountOpen: boolean;
	onAccountChange: (open: boolean) => void;
	howToOpen: boolean;
	onHowToChange: (open: boolean) => void;
	showHiatusModal: boolean;
	onHiatusClose: () => void;
	showMilestoneModal: boolean;
	onMilestoneClose: () => Promise<void>;
	pendingAchievement: Achievement | null;
	user: UsersDto | null | undefined;
	showCrowdLockModal: boolean;
	onCrowdLockClose: () => void;
	popupCategories: string[];
	onPopupCategoriesChange: (categories: string[]) => void;
	setSidebarOpen: (open: boolean) => void;
	authModalOpen: boolean;
	onAuthModalChange: (open: boolean) => void;
	productUpdatePopup: ProductUpdatePopupDto | null;
	productUpdateOpen: boolean;
	onProductUpdateClose: () => void;
}

export function LayoutModals({
	accountOpen,
	onAccountChange,
	howToOpen,
	onHowToChange,
	showHiatusModal,
	onHiatusClose,
	showMilestoneModal,
	onMilestoneClose,
	pendingAchievement,
	user,
	showCrowdLockModal,
	onCrowdLockClose,
	popupCategories,
	onPopupCategoriesChange,
	setSidebarOpen,
	authModalOpen,
	onAuthModalChange,
	productUpdatePopup,
	productUpdateOpen,
	onProductUpdateClose,
}: LayoutModalsProps) {
	const [termsAgreed, setTermsAgreed] = useState(false);
	const termsAccepted = !user || user.viewed_popups?.accepted_latest_terms !== false;

	const activeModal = (() => {
		if (showHiatusModal) return 'hiatus';
		if (!termsAccepted && !termsAgreed) return 'terms';
		if (showMilestoneModal) return 'milestone';
		if (popupCategories.length > 0) return 'smartRating';
		if (productUpdateOpen) return 'productUpdate';
		return null;
	})();

	return (
		<>
			{user && (
				<>
					<AccountModal
						open={accountOpen}
						onOpenChange={onAccountChange}
						setSidebarOpen={setSidebarOpen}
						user={user}
					/>

					<HiatusModal
						open={activeModal === 'hiatus'}
						onClose={onHiatusClose}
						playerName={user.full_name || ''}
					/>

					<NewTermsDialog
						user={user}
						open={activeModal === 'terms'}
						onAgree={() => setTermsAgreed(true)}
					/>

					<MilestoneModal
						open={activeModal === 'milestone'}
						onClose={onMilestoneClose}
						milestone={pendingAchievement?.type}
						milestoneDetails={pendingAchievement?.details}
					/>

					{popupCategories.length > 0 && (
						<SmartRatingCelebratory
							key={popupCategories[0]}
							open={activeModal === 'smartRating'}
							categoryId={popupCategories[0]}
							onClose={() => {
								onPopupCategoriesChange([]);
							}}
						/>
					)}

					{/*{!isProbabilityEventPage && <IntroVideoDialog user={user} />}*/}

					{/*{user.role === UserRole.User && !isProbabilityEventPage && (*/}
					{/*	<NewFeatureUserInsightPopup isHiatusModalOpen={showHiatusModal} user={user} />*/}
					{/*)}*/}

					{productUpdatePopup && (
						<ProductUpdatePopup
							popup={productUpdatePopup}
							open={activeModal === 'productUpdate'}
							onClose={onProductUpdateClose}
						/>
					)}
				</>
			)}

			<AuthModal open={authModalOpen} onOpenChange={onAuthModalChange} />

			<HowToPlayModal open={howToOpen} onOpenChange={onHowToChange} />

			<CrowdLockIntroModal open={showCrowdLockModal} onClose={onCrowdLockClose} />
		</>
	);
}
